import React from "react";
import { motion } from "framer-motion";
import { Shield } from "lucide-react";

const fadeUp = (delay = 0) => ({
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6, delay, ease: "easeOut" },
});

const TermsAndConditions = () => {
    return (
        <div className="min-h-screen bg-white relative overflow-hidden">
            {/* Hero Section */}
            <div className="relative bg-gradient-to-br from-[#00809D] via-[#006d87] to-[#005568] overflow-hidden">
                <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3" />
                <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-white/5 rounded-full translate-y-1/2 -translate-x-1/3" />

                <div className="relative z-10 pt-32 sm:pt-40 lg:pt-48 pb-24 sm:pb-28 lg:pb-32 px-4 sm:px-6 lg:px-8 text-center">
                    <motion.div initial={{ opacity: 0, y: 25 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
                        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-md px-5 py-2 rounded-full mb-6 border border-white/20">
                            <Shield className="w-4 h-4 text-white/90" />
                            <span className="text-white/90 font-medium text-sm">Terms</span>
                        </div>
                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight tracking-tight">
                            Terms and Conditions
                        </h1>
                        <p className="text-lg sm:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed">
                            The rules and guidelines for using Adsurg services.
                        </p>
                    </motion.div>
                </div>

                <div className="absolute bottom-0 left-0 right-0">
                    <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
                        <path d="M0 80V40C240 0 480 0 720 20C960 40 1200 60 1440 40V80H0Z" fill="white" />
                    </svg>
                </div>
            </div>

            {/* Content Section */}
            <div className="px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
                <div className="max-w-4xl mx-auto text-gray-600">
                    <motion.div {...fadeUp()}>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                        <p className="mb-6">By accessing and using the services provided by Adsurg, you agree to comply with and be bound by these Terms and Conditions. If you do not agree with any part of these terms, please refrain from using our services.</p>

                        <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Services Scope</h2>
                        <p className="mb-6">Adsurg provides digital performance marketing and strategic advertising services. The specific scope, deliverables, and timelines for each client will be outlined in a separate Service Agreement or Proposal.</p>

                        <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Client Obligations</h2>
                        <p className="mb-6">Clients are responsible for providing all necessary access, assets, and approvals required for Adsurg to perform the agreed-upon services. Delays in providing these materials may result in project delays or additional fees.</p>

                        <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Payment Terms</h2>
                        <p className="mb-6">Payments for our services are expected as per the schedule outlined in the Service Agreement. Ad spend is managed separately and must be strictly funded by the client. Late payments may result in the suspension of campaign management services.</p>

                        <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Intellectual Property</h2>
                        <p className="mb-6">All ad copies, strategies, and reports created by Adsurg remain the property of Adsurg until full payment has been received, at which point ownership of final deliverables transfers to the client, unless otherwise stated in the agreement.</p>

                        <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Limitation of Liability</h2>
                        <p className="mb-6">Adsurg shall not be liable for any indirect, incidental, or consequential damages resulting from the use or inability to use our services, or from the performance of the advertising platforms we manage.</p>

                        <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Amendments</h2>
                        <p className="mb-6">We reserve the right to modify these Terms and Conditions at any time. Significant changes will be communicated to active clients. Continued use of our services after such modifications constitutes acceptance of the new terms.</p>

                        <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Contact Information</h2>
                        <p className="mb-6">
                            For any questions regarding these Terms and Conditions, please reach out to us via our <a href="/contact" className="text-[#00809D] font-semibold hover:underline">contact form</a>.
                        </p>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
